//import libraries
import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Resolve } from '@angular/router';

//import constants
import { AppSettings } from '../constants/app-settings';
import { AppBackRoutes } from '../constants/app-back-routes';


//import language
import { EmployeesListLang,EmployeeCreateLang,EmployeesViewLang,EmployeesDpiLang } from '../languages/Employees.Lang';

//import services
import { GeneralService } from '../services/general.service';

//import classes
// import {
//     SettingsFormMangIn, SettingsFormMangOut
//   } from '../classes/settings.model';

import {
    ServicingList, ServicingGeneralGet, ServicingGeneralPostIn, ServicingGeneralPostOut } from '../classes/servicing.model';

    

@Injectable()


export class EmployeeService implements Resolve<Observable<any>>{

    constructor(
        private http: HttpClient,
        private generalService: GeneralService,
    ) { }

    resolve() {
        return this.ServicingGetData();
    }

    getSkillEmployees(id,ref_id){
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.getSkillEmployees+"/"+id+"/"+ref_id;
        return this.http.get<any>(url);
    }

    ServicingGetData(): Observable<ServicingList> {

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.servicingMaintenancelist;
        return this.http.get<any>(url);

    }
    
    listLang(details: any) {

        if (!details) return;

        // console.log('test');

        let instance = new EmployeesListLang(details.data.language);
        return instance.lang();

    }


    AddDpiLang(details: any) {
        if (!details) return;
        let instance = new EmployeesDpiLang(details.data.language);
        return instance.lang();
    }

    employeeviewLang(details: any) {

        if (!details) return;
        let instance = new EmployeesViewLang(details.data.language);
        return instance.lang();

    }

    ServicingMaintenanceLang(details: any) {

        if (!details) return;
        // let instance = new ServicingMaintenanceLang(details.data.language);
        // return instance.lang();
    }

    
    GeneralPostData(data: ServicingGeneralPostIn) {

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.profileGeneralPost;
        return this.http.post<ServicingGeneralPostOut>(url, data);
    }

    generalLang(details: any) {

        if (!details) return;

        // let instance = new ServicingGeneralLang(details.data.language);
        // return instance.lang();

    }


    createLang(details: any) {

        if (!details) return;

        let instance = new EmployeeCreateLang(details.data.language);
        return instance.lang();
    }


    // DpicreateLang(details: any) {

    //     if (!details) return;

    //     let instance = new DpicreateLang(details.data.language);
    //     return instance.lang();
    // }


    update(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.employeeCreate;
        return this.http.post<any>(url, data);
    }   

    updateskills(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.employeeSkillsInsert;
        return this.http.post<any>(url, data);
    }

    addSkillAnaylsis(data:any){
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.addSkillEmployees;
        return this.http.post<any>(url, data);
    }

    addSkillAnaylsisDepartment(data:any){
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.addSkillAnalysisDepartment;
        return this.http.post<any>(url, data);
    }

    update_report(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.updateReport;
        return this.http.post<any>(url, data);
    }


    update_mail(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.updateMail;
        return this.http.post<any>(url, data);
    }

    update_afdreport(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.updateafdReport;
        return this.http.post<any>(url, data);
    }

    update_atdreport(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.updateatdReport;
        return this.http.post<any>(url, data);
    }

    updateCourse(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.updateCourse;
        return this.http.post<any>(url, data);
    }

    searchCourse(cname: any) {
        // console.log(data); return false;
        let data = { 'course_name': cname };


        let url = AppSettings.API_ENDPOINT + AppBackRoutes.search_course;
        return this.http.post<any>(url, data);
    }

    sorting(data: any, table: any) {

        let data1 = { 'id': data, 'table': { 'table_name': 'kaizen_employees', 'id': 'employeeId', 'order': 'sort1' } };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.employeeSorting;
        // console.log(url);
        return this.http.post<any>(url, data1);
    }

    certification_save(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.certificationSave;
        return this.http.post<any>(url, data);
    }


    certification_delete(id: any, ref_id:any) {

        let data = { 'ref_id': ref_id, 'action' : 'certification_delete','emp_id': id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.certificationDelete;
        return this.http.post<any>(url, data);
    }


    update_extraordinary(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.exordinary_servicing;
        return this.http.post<any>(url, data);
    }

    update_ordinary(data: any) {
        // console.log(data); return false;
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.ordinary_servicing;
        return this.http.post<any>(url, data);
    }

    update_mplans(data: any) {
        // console.log(data); return false;
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.ordinary_servicing;
        return this.http.post<any>(url, data);
    }

    update_maintenance(data: any) {
        // console.log(data); return false;
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.update_maintenance;
        return this.http.post<any>(url, data);
    }
    
    update_documents(data: any) {
        // console.log(data); return false;
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.update_documents;
        return this.http.post<any>(url, data);
    }


    edit(id: any) {
        let data = {'action' : 'add_employee', 'id' : id};
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.getEmployeeList;
        return this.http.post<any>(url, data);
    }


    getmail(id: any) {
        let data = {'action' : 'add_employee', 'id' : id};
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.getdpimail;
        return this.http.post<any>(url, data);
    }

    editskills(id: any) {
        let data = {'id' : id};
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.getSkillsList;
        return this.http.post<any>(url, data);
    }

    edit_protective(id: any) {

        let data = { 'id': id };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.editFirstDevice;
        return this.http.post<any>(url, data);
    }
    

    duplicate(id: any) {

        let data = [id];
        return this.multiDuplicate(data);
        
    }

    multiDelete(ids: any) {
        let data = { 'cid': ids };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.employeeMultiDelete;
        return this.http.post<any>(url, data);
    }
    


    multiSkillsDelete(ids: any) {
        let data = { 'cid': ids };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.skillsMultiDelete;
        return this.http.post<any>(url, data);
    }

    multiSkillsAnalysisDelete(ids: any) {
        let data = { 'id': ids };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.skillsAnalysisMultiDelete;
        return this.http.post<any>(url, data);
    }    

    multiCoursesDelete(ids: any) {
        let data = { 'cid': ids };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.coursesMultiDelete;
        return this.http.post<any>(url, data);
    }
    


    multiDelete1(ids: any) {
        let data = { 'id': ids };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.servicingMainMultiDelete;
        return this.http.post<any>(url, data);
    }

    multiDelete_maintenance(ids: any) {
        let data = { 'plan_ids': ids, 'action' : 'plans_table_delete' };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.multiDeleteMaintenance;
        return this.http.post<any>(url, data);
    }


    
        
    delete_mextraordinary(ids: any) {
        let data = { 'id': ids };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.delete_mextraordinary;
        return this.http.post<any>(url, data);
    }
    
        
        
    delete_msdocuments(ids: any) {
        let data = { 'id': ids,'action' : 'multidelete_documents' };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.delete_msdocuments;
        return this.http.post<any>(url, data);
     }


     multiDuplicate(ids: any) {

        let data = {'id' : ids};

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.employeeMultiDuplicate;
        return this.http.post<any>(url, data);

     }
    
     multiSkillsDuplicate(ids: any) {

        let data = {'id' : ids};

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.SkillsMultiDuplicate;
        return this.http.post<any>(url, data);

     }
    
     multiCoursesDuplicate(ids: any) {

        let data = {'id' : ids};

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.coursesMultiDuplicate;
        return this.http.post<any>(url, data);

    }


    multiOrdDuplicate(ids: any) {

        let data = {'id' : ids};

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.multiOrdDuplicate;
        return this.http.post<any>(url, data);

    }
    
    
    multiExtraDuplicate(ids: any) {

        let data = {'id' : ids};

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.multiExtraDuplicate;
        return this.http.post<any>(url, data);

    }

    multiDuplicate_maintenance(ids: any) {

        let data = {'plan_ids' : ids, 'action' : 'plans_table_copy' };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.multiDuplicateMaintenance;
        return this.http.post<any>(url, data);

    }

    doc_multiDuplicate(ids: any) {

        let data = {'id' : ids, 'action' : 'multiduplicate_documents'};

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.duplicate_msdocuments;
        return this.http.post<any>(url, data);

    }

    

    getList(){
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.employeeList;
        return this.http.get<any>(url);
    }

    getCourseDetails(id){
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.employeeCourseDetails + "/" + id;
        return this.http.get<any>(url);
    }

    getSkillsList(){

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.skillsanalysisList;
        return this.http.get<any>(url);

    }

    skillrecords(resp) {

        console.log(resp);

        return (resp) ? resp.data.skills_records : null;
    }

    
    getEmployeeList() {

        let data = { 'action': 'add_employee', 'id' : '' };
        
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.getEmployeeList;
        return this.http.post<any>(url, data);
    }

        
    getProtectivedevice() {

       
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.getProtectivedevice;
        return this.http.get<any>(url);
    }


    getMaintenanceformdata(){

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.getMaintenanceformdata;
        return this.http.get<any>(url);

    }


    getMaintenanceList(){
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.maintenancePlans;
        return this.http.get<any>(url);
    }
    

    emptrainingData(id: any){

        let data = { 'eid': id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.emptrainingData;
        return this.http.post<any>(url, data);

        
    }

    getCoursesList() {
        
        let data = {'action' : 'add_courses', 'id' : ''};


        let url = AppSettings.API_ENDPOINT + AppBackRoutes.courseList;
        return this.http.post<any>(url, data);

    }


    CoursesEdit(id: any) {

        let data = {'action' : 'edit_courses', 'id' : id};


        let url = AppSettings.API_ENDPOINT + AppBackRoutes.coursesEdit;
        return this.http.post<any>(url, data);

    }

    ordinaryData(id: any){

        let data = { 'oid': id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.ordinaryData;
        return this.http.post<any>(url, data);

    }


    documentsData(){

        let data = { 'action': 'add_documents' };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.documentsData;
        return this.http.post<any>(url, data);

    }


    generalList(id: any){

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.employee_view + '/' + id;
        return this.http.get<any>(url);

    }

    notifyList(id: any){

        let data = { 'eid': id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.notifyList;
        return this.http.post<any>(url, data);

    }

    medicalList(id: any){

        let data = { 'eid': id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.medicalList;
        return this.http.post<any>(url, data);

    }



    GeneralGetServData(resp: ServicingGeneralGet) {
        console.log(resp);
        return (resp) ? resp.data.single_data : null;
    }


    //     resolve() {
    //     return this.FetchDetails();
    // }

    // FetchDetails(): Observable<any> {

    //     let url = AppSettings.API_ENDPOINT + AppBackRoutes.settingsData;
    //     return this.http.get<any>(url);

    // }

    getlistLangForm(details: any) {

        if (!details) return;

        // let instance = new EmployeeListLangForm(details.language);
        // return instance.lang();

    }

    getEditLangForm(details: any) {

        if (!details) return;

        // let instance = new SettingsEditLangForm(details.language);
        // return instance.lang();

    }

    getSettingsLang(details: any) {

        if (!details) return;

        // let instance = new SettingsSettingsLang(details.language);
        // return instance.lang();

    }

    // FormMangServCall(input : SettingsFormMangIn) {
    //     let url = AppSettings.API_ENDPOINT + AppBackRoutes.settingsFormMang;
    //     return this.http.post<SettingsFormMangOut>(url, input);
    // }

    FormMangUpdate(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.settingsFormMang;
        return this.http.post<any>(url, data);
    }

    settingsUpdate(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.settingsSettings;
        return this.http.post<any>(url, data);
    }

    
    delete(id: any) {

        let data = { 'eid': id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.employeeDelete;
        return this.http.post<any>(url, data);

    }

    addParticipants(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.addParticipantDelete;
        return this.http.post<any>(url, data);
    }

    deleteEmployee(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.removeParticipantDelete;
        return this.http.post<any>(url, data);
    }

    deleteCertificate(data:any){
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.removeParticipant;
        return this.http.post<any>(url, data);        
    }

    updateOption(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.coursesUpdateOption;
        return this.http.post<any>(url, data);
    }
    
        
    deleteCourses(id: any) {

        let data = { 'cid': id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.coursesDelete;
        return this.http.post<any>(url, data);

    }


    deleteSkills(id: any) {

        let data = { 'skid': id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.skillsDelete;
        return this.http.post<any>(url, data);

    }


    deletesdpi(id: any, empID: any) {

        let data = { 'id': id,'empid': empID };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.removeFirstDevice;
        return this.http.post<any>(url, data);

    }

     deletetdpi(id: any, empID: any, sid:any) {

        let data = { 'did': id,'empid': empID, 'sid': sid };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.removeThirdDevice;
        return this.http.post<any>(url, data);

    }


    delete_extraordinary(id: any) {

        let data = { 'id': id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.deleteExtraordinary;
        return this.http.post<any>(url, data);

    }

    delete_ordinary(id: any) {

        let data = { 'id': id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.deleteOrdinary;
        return this.http.post<any>(url, data);

    }

    deleteMultiOrdinary(id: any) {

        let data = { 'cid': id };

        // console.log(data);

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.deleteMultiOrdinary;
        return this.http.post<any>(url, data);

    }

    
    
    delete_maintenance(id: any) {

        let data = { 'plan_id': id, 'action' : 'plans_delete' };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.deleteMaintenance;
        return this.http.post<any>(url, data);

    }

    
    
    delete_sdocuments(id: any) {

        let data = { 'docId': id, 'action' : 'delete_documents' };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.deleteDocuments;
        return this.http.post<any>(url, data);

    }

    updateImport(profileImage: any){

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.employeeuploadExcel;
 
         let headers = new HttpHeaders({
             'Content-Type': 'application/json'
          });
 
         let options = {
             headers: headers
          }
 
         let data = {'profile' : profileImage};
          return this.http.post<any>(url, data, options);
 
    }
    
    updateImportSkills(profileImage: any) {
        
        console.log('test12'); 

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.skillsuploadExcel;
 
         let headers = new HttpHeaders({
             'Content-Type': 'application/json'
          });
 
         let options = {
             headers: headers
          }
 
         let data = {'profile' : profileImage};
          return this.http.post<any>(url, data, options);
 
    }
    


    // updateImport(profileImage: any){

    //     let url = AppSettings.API_ENDPOINT + AppBackRoutes.documentsuploadExcel;
 
    //      let headers = new HttpHeaders({
    //          'Content-Type': 'application/json'
    //       });
 
    //      let options = {
    //          headers: headers
    //       }
 
    //      let data = {'profile' : profileImage,'action': 'import_documents'};
    //       return this.http.post<any>(url, data, options);
 
    // }
    


    mLangData(details: ServicingList) {
        if (!details) return;

        // console.log('test');

        // let instance = new ServicingMaintenancePlanningLang(details.data.language);
        // return instance.lang();


        // if (!resp)
        //     return;

        // let lang = {};

        // let gen = resp.data.language.general;
        // // console.log(gen);
        // lang = Object.assign(lang, { general: this.generalService.service_inject(ServicingUserLang.general, gen) });

        // let dash = resp.data.language.service;
        // lang = Object.assign(lang, { user: this.generalService.service_inject(ServicingUserLang.user, dash) });

        // return lang;
    }


    ServicingOrdinaryLang(details: ServicingList) {
        if (!details) return;

        // let instance = new ServicingOrdinaryLang(details.data.language);
        // return instance.lang();

    }

    ServicingExOrdinaryLang(details: ServicingList) {
        if (!details) return;

        // let instance = new ServicingExOrdinaryLang(details.data.language);
        // return instance.lang();

    }
    

    ServicingDocumentsLang(details: ServicingList) {
        if (!details) return;

        // let instance = new ServicingDocumentsLang(details.data.language);
        // return instance.lang();

    }

    MaintenanceData(resp: ServicingList) {

        // console.log(resp);

        return (resp) ? resp.data.all_mplans : null;
    }

    calendar(){

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.servicingCalendar;
        return this.http.get<any>(url);

    }

    calendarLang(details: any) {

        if (!details) return;
        // let instance = new ServicingCalendarLang(details.language);
        // return instance.lang();

    }

    turnoff(sID : any,pid : any,rid : any) {

        let data = { 'sID': sID, 'pid': pid, 'rid': rid };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.servicingTurnoff;
        return this.http.post<any>(url, data);

    }

    active_status(date : any,plan_id_forcd : any,pservice_id : any) {

        let data = { 'start_date': date, 'plan_id_forcd': plan_id_forcd, 'service_id': pservice_id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.active_status;
        return this.http.post<any>(url, data);

    }

    Plancodecheck(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.check_plancode;
        return this.http.post<any>(url, data, { headers: new HttpHeaders({'loader': 'false'}) });
    }


    hired(id: any) {

        let data = { 'id': id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.employeeHired;
        return this.http.post<any>(url, data);

    }


    resign(id: any) {

        let data = { 'id': id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.employeeResign;
        return this.http.post<any>(url, data);

    }

    uploadFile(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.uploadCertificate;
        return this.http.post<any>(url, data);
    }
        

    // file from event.target.files[0]
    uploadFiles(file: File) {

        let formData:FormData = new FormData();
        formData.append('uploadFile', file, file.name);
        let headers = new HttpHeaders();
        /** In Angular 5, including the header Content-Type can invalidate your request */
        headers.append('Content-Type', 'multipart/form-data');
        headers.append('Accept', 'application/json');
        let options = { headers: headers };

        return this.http.post<any>(AppSettings.API_ENDPOINT + AppBackRoutes.uploadCertificate, formData, options);
        const req = new HttpRequest('POST', AppSettings.API_ENDPOINT + AppBackRoutes.uploadCertificate, formData, options);
        return this.http.request(req);
        // let formData = new FormData();
        // formData.append('upload', file);

        // let params = new HttpParams();

        // const options = {
        // params: params,
        // reportProgress: true,
        // };

        // const req = new HttpRequest('POST', AppSettings.API_ENDPOINT + AppBackRoutes.uploadCertificate, formData, options);
        // return this.http.request(req);
    }      


}